import React from 'react';
import ContentArea from "../components/content-area/Content";
import ComingSoonPage from "../components/homepage/ComingSoonPage";
import SubscriptionIconPng from "../assets/icons/subscriptions.png";

const Subscriptions = () => (
  <ContentArea title="Subscriptions" icon={SubscriptionIconPng} container={false}>
    <ComingSoonPage />
  </ContentArea>
);

export default Subscriptions;
